// React
import React from 'react';
// External libraries
import { Form, Button } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
// Internal
import { login, loginNewUser } from 'services/users';
import getFormFieldVal from 'utils/getFormFieldVal';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// Styles
import './styles.scss';

class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        const params = new URLSearchParams(props.location.search);
        const email = params.get('email') ? params.get('email') : '';
        this.state = {
            email: props.email ? props.email : email,
            password: props.password ? props.password : '',
            errors: [],
            isPwdHidden: true,
            isLoading: false,
            cognitoError: '',
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
        const fieldObj = getFormFieldVal(event);
        this.setState((prevState) => {
            if (prevState.errors.length) {
                const errors = prevState.errors.filter((error) => error !== 'invalid-data');
                const errorIndex = errors.indexOf(event.target.name);
                if (errorIndex >= 0) {
                    errors.splice(errorIndex, 1);
                }
                return { ...fieldObj, errors };
            }
            return { ...fieldObj };
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const errorList = [];
        this.state.isLoading = true;
        // Set the password error if invalid
        if (this.state.password === '') errorList.push('password');
        /**
         * Validates email
         * @todo Use email or username?
         */
        // const expression = /\S+@\S+/;
        // const validEmail = expression.test(String(this.state.email).toLowerCase());
        const validEmail = this.state.email;

        // Set the email error if invalid
        if (!validEmail) errorList.push('email');

        this.setState({ errors: errorList });
        if (errorList.length > 0) return false;

        // Requests the login authentication
        login(this.state.email, this.state.password)
            .then((response) => {
                if (!response.signInUserSession) {
                    if (response.challengeName === 'NEW_PASSWORD_REQUIRED') {
                        loginNewUser(response)
                            .then(() => {
                                this.props.history.push(`/forgot-password?email=${this.state.email}`);
                            });
                    }
                    return;
                }

                // Response handler
                if (!this.props.bookingId && !this.props.quotedProductId) {
                    this.props.history.push('/dashboard');
                } else {
                    this.props.history.push(`/engraving/check-existing?`
                        + `staff=1&bookingId=${this.props.bookingId}&quotedProductId=${this.props.quotedProductId}`);
                }
            })
            .catch((error) => {
                this.state.isLoading = false;
  				const detail = error?.detail || error?.message || 'Something went wrong';
  				this.setState({ errors: ['invalid-data'], cognitoError: detail });
            });
    }

    hasError(key) {
        return this.state.errors.indexOf(key) !== -1;
    }

    render() {
        return (
            <>
                <Form className="inline-block-below-lg">
                    <Form.Group controlId="email" className="control-group control-email inline-block-below-lg">
                        <Form.Label>Username</Form.Label>
                        <Form.Control
                            className={`${this.hasError('email')
                                || this.hasError('invalid-data') ? 'is-invalid' : ''} `
                            + `inline-block-below-lg`}
                            name="email"
                            value={this.state.email}
                            onChange={this.handleInputChange}
                            type="email"
                            autoFocus
                            placeholder="Enter email"
                        />
                        {
                            this.hasError('email')
                                ? (
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="invalid-feedback"
                                    >
                                        Username is invalid or missing
                                    </Form.Control.Feedback>
                                ) : null
                        }
                    </Form.Group>

                    <Form.Group controlId="password" className="control-group inline-block-below-lg">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            className={`${this.hasError('password')
                            || this.hasError('invalid-data') ? 'is-invalid' : ''} `
                            + `inline-block-below-lg`}
                            name="password"
                            value={this.state.password}
                            onChange={this.handleInputChange}
                            type={this.state.isPwdHidden ? 'password' : 'text'}
                            placeholder="Password"
                        />
                        {
                            this.state.isPwdHidden
                                ? (
                                    <BsEye
                                        className={
                                            this.hasError('password') || this.hasError('invalid-data')
                                                ? 'login-input-icon error-margin is-invalid'
                                                : 'login-input-icon'
                                        }
                                        size="24"
                                        onClick={() => this.setState({ isPwdHidden: false })}
                                    />
                                ) : (
                                    <BsEyeSlash
                                        className={
                                            this.hasError('password') || this.hasError('invalid-data')
                                                ? 'login-input-icon error-margin is-invalid'
                                                : 'login-input-icon'
                                        }
                                        size="24"
                                        onClick={() => this.setState({ isPwdHidden: true })}
                                    />
                                )
                        }
                        <Form.Control.Feedback
                            type="invalid"
                            className={
                                this.hasError('password') || this.hasError('invalid-data')
                                    ? 'invalid-feedback'
                                    : 'hidden'
                            }
                        >
                            {
                                this.hasError('password')
                                    ? 'Password is invalid or missing'
                                    : this.state.cognitoError ? this.state.cognitoError
                                    : 'Please verify your email and password are correct and try again.'
                            }
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Button disabled={this.state.isLoading} className="btn-primary inline-block-below-lg" onClick={this.handleSubmit} type="submit">
                        {this.state.isLoading ?
                            <FontAwesomeIcon icon={faSpinner} className="fa-solid fa-cog fa-spin" /> : 'Submit'}
                    </Button>
                </Form>
                <div className="link-wrapper">
                    <Link
                        className="link"
                        to={{
                            pathname: '/forgot-password',
                            search: this.state.email ? `?email=${this.state.email}` : null
                        }}
                    >
                        Forgot your password?
                    </Link>
                </div>
            </>
        );
    }
}

export default withRouter(LoginForm);
